import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class RequestIdInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestId = sessionStorage.getItem('X-Request-ID');
    if (requestId != null) {
      const XRequestReq = req.clone({
        headers: req.headers.set('X-Request-ID', requestId),
      });
      return next.handle(XRequestReq);
    }
    return next.handle(req);
  }
}
